import $ from "jquery";
import { app } from '../../utils/store';

export default class Filters {
    constructor() {
        this.filters = {
            btn_view_categories: document.getElementById('btn-view-categories'),
            btn_close_categories: document.getElementById('btn-close-categories'),
            navbar_filter: document.querySelector('.nav-filters'),
            products_list: document.querySelector('.products-list'),
        }

        this.body = document.querySelector('html');
        this.top_header = document.querySelector('.header .top-header');
        this.navbar = document.querySelector('.header .navbar')

        this.input = document.querySelectorAll('input[data-filter-type]');
        this.elements = document.querySelectorAll('.tease[data-filters]');
        this.btn_view_all = document.querySelector('.btn-view-all');

        if (this.filters.navbar_filter){
            this.viewAll();
        }
        this.body.style.setProperty('--top-header-height', `${this.top_header.offsetHeight}px`)
        this.body.style.setProperty('--navbar-height', `${this.navbar.offsetHeight}px`)
    }

    init() {
        this.viewCloseNavFilter();
        this.filterProduct();
        
    }

    viewAll = () =>{
        this.elements.forEach((element, i) => {
            if (i > 23) {
                element.classList.add('d-none')
            }
        })
        this.btn_view_all.addEventListener('click', (event) => {
            this.elements.forEach((element, i) => {
                event.preventDefault();
                element.classList.remove('d-none');
                event.target.classList.add('d-none');
                
            })
        })
    }

    viewCloseNavFilter = () => {
        this.filters.btn_view_categories.addEventListener('click', (event) => {
            event.preventDefault();
            
            this.filters.navbar_filter.classList.remove('d-none');
            this.filters.products_list.classList.add('col-md-9');
            this.filters.products_list.classList.add('three-columns');
            var media = window.matchMedia("(max-width: 576px)");
            if (media.matches) {
                window.scrollTo(0, 0);
                this.body.style.setProperty('overflow','hidden');
                this.body.style.setProperty('height','100vh');
            }
        });

        this.filters.btn_close_categories.addEventListener('click', (event) => {
            event.preventDefault();
            this.filters.navbar_filter.classList.add('d-none');
            this.filters.products_list.classList.remove('col-md-9');
            this.filters.products_list.classList.remove('three-columns');
            var media = window.matchMedia("(max-width: 576px)");
            if (media.matches) {
                this.body.style.setProperty('overflow','visible');
                this.body.style.setProperty('height','auto');
            }
        });
    }

    filterProduct = () => {
        this.input.forEach((input) => {
            input.addEventListener('click', (event) => {
                event.target.classList.toggle('active');
                this.input_active = document.querySelectorAll('input[data-filter-type].active');
                this.filtered = new Array();
                this.visible_element = new Array();
                this.btn_view_all.classList.add('d-none');

                this.input_active.forEach( (active) => {
                    var filter = active.getAttribute('data-filter-type');
                    this.filtered.push(filter)
                })

                if (this.filtered.length > 0 ){
                    this.elements.forEach( (item) => {
                        item.classList.add('d-none');
                    })
                    this.elements.forEach( (item) => {
                        var data_filter = item.getAttribute('data-filters');
                        this.data_filter = data_filter.split(' ');
                        this.filtered.forEach( (active) => {
                            if(this.data_filter.includes(active)){
                                this.visible_element.push(item);
                            }
                        });
                        
                    })
                    this.visible_element.forEach((item_view) => {
                        item_view.classList.remove('d-none');
                    })

                } else {
                    this.elements.forEach( (item) => {
                        item.classList.remove('d-none');
                    })
                }
            })
        })
    }
    
}
